export default __webpack_public_path__ + "static/trust-aebe1f0141bebe368df92d873ec6a068.png";